import React from "react";
import styled from 'styled-components';
import imageBackground from '../../assets/Go_City_Darker_Background.jpeg';
import HelpForm from "../../components/HelpForm/HelpForm";

const Help = () => {

    return (
        <Container style={{backgroundImage: `url(${imageBackground})`}}>
            <HelpForm />
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    overflow:auto;
    width: 100vw;
    height:100%;
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    webkit-background-size: cover;
    justify-content:center;
`

export default Help;